<template>
  <div id="app">
    <div class="header-width divcss5" v-show="$route.name!='mangement'&&$route.name!='login'&&$route.name!='webproductlist'&& $route.name!='JRS' && $route.name!='yjyfkcontent'  && $route.name!='pdf'">
      <headercoms></headercoms>
    </div>
    <router-view v-if="isRouterAlive"/>
    <div class="header-width divcss5" v-show="$route.name!='mangement'&&$route.name!='login'&&$route.name!='webproductlist'&& $route.name!='JRS' && $route.name!='yjyfkcontent'  && $route.name!='pdf'">
      <footercoms></footercoms>
    </div>
  </div>
</template>

<script>
  import headercoms from "@/components/commoncoms/header"
  import footercoms from "@/components/commoncoms/footer"

  export default {
    name: 'App',   provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return {
        isRouterAlive:true,
      }
    },
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        });
      },
    },

    components:{
      headercoms:headercoms,
      footercoms:footercoms
    }
  }

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue